export default "__VITE_ASSET__BNR36rom__"